import { toDateTimeStr } from '@mi-front/core';
import { ModalStateProps } from '@mi-front/ui';
import { useActiveStation } from '../../../../core/stations/hooks/useActiveStation';
import { useRangeAuditResults } from '../../../logger/screens/stream/components/audit/useRangeAuditResults';
import {
  useClearCursor,
  useCursor,
} from '../../../logger/screens/stream/stores/stream-screen.store';
import { LiveMentionsAddPage } from '../../screens/live-mentions-add/LiveMentionsAddPage';

export function LiveMentionAddFromCursor(p: ModalStateProps) {
  const station = useActiveStation();
  const ts = useCursor();
  const clearCursor = useClearCursor();
  const { reload } = useRangeAuditResults();

  if (!ts) {
    return null;
  }

  return (
    <LiveMentionsAddPage
      station={station}
      datetime={toDateTimeStr(ts)}
      onSuccess={() => {
        reload();
        clearCursor();
      }}
      {...p}
    />
  );
}
